import React from 'react';
import { useUser } from '../context/userContext';

const TemperatureUnitSelector: React.FC = () => {
  const { unit, toggleUnit } = useUser();

  const handleClick = (selectedUnit: 'Celsius' | 'Fahrenheit') => {
    if (unit !== selectedUnit) toggleUnit();
  };

  return (
    <div className="temperatureUnitSelector">
      <button
        className={unit === 'Celsius' ? 'active' : ''}
        onClick={() => handleClick('Celsius')}
      >
        °C
      </button>
      <button
        className={unit === 'Fahrenheit' ? 'active' : ''}
        onClick={() => handleClick('Fahrenheit')}
      >
        °F
      </button>
    </div>
  );
};

export default TemperatureUnitSelector;
